import type { FC, ReactNode } from 'react';
import { AlertCircle } from 'lucide-react';

type Props = {
  label?: ReactNode;
  required?: boolean;
  helper?: ReactNode;
  error?: ReactNode;
  children: ReactNode;
  className?: string;
  /** 占满一行（如 textarea / 日期范围） */
  fullWidth?: boolean;
};

/** Showcase §2：Label 在上 + helper / error */
export const IpcFormField: FC<Props> = ({
  label,
  required = false,
  helper,
  error,
  children,
  className,
  fullWidth = false,
}) => (
  <div
    className={['ipc-form-field', fullWidth ? 'ipc-form-field--full' : '', error ? 'ipc-form-field--error' : '', className]
      .filter(Boolean)
      .join(' ')}
  >
    {label != null && label !== '' && (
      <label className="ipc-form-field__label">
        {label}
        {required && <span className="ipc-form-field__required">*</span>}
      </label>
    )}
    <div className="ipc-form-field__control">{children}</div>
    {error != null && error !== '' ? (
      <p className="ipc-form-field__error">
        <AlertCircle size={12} aria-hidden />
        {error}
      </p>
    ) : helper != null && helper !== '' ? (
      <p className="ipc-form-field__helper">{helper}</p>
    ) : null}
  </div>
);
